export class Applicant {
    _id: string;
    applicationType: string;
    referrerSource: string;
    user: any;
    resume_path: string;
    comments: string;
    job: any;
    ipAddress: string;
    smsOptIn: boolean;
    emailPhoneOptIn: boolean;
    deleted: boolean;
    createdAt: Date;
    updatedAt: Date;
    message: string;
    resumeTitle: string; // For select resume component
    first_name: string; // For filters
    last_name: string; // For filters
    profession: string; // For filters
    hasSearchTerms; // For filters
    dateCreatedRange; // For filters
    dateCreated; // For filters
    dateCreatedEnd; // For filters
}